'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = getRowIntervalIndexes;

var _getRowIndexByKey = require('../rows/getRowIndexByKey');

var _getRowIndexByKey2 = _interopRequireDefault(_getRowIndexByKey);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function getRowIntervalIndexes(_ref) {
  var indexes = _ref.indexes,
      startRowKey = _ref.startRowKey,
      endRowKey = _ref.endRowKey;
  var start = (0, _getRowIndexByKey2["default"])(indexes, startRowKey);
  var end = (0, _getRowIndexByKey2["default"])(indexes, endRowKey);
  return {
    start: Math.min(start, end),
    end: Math.max(start, end)
  };
}